import { Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';

export interface EventLogResult {
  table: string;
  timestamp: number;
  properties: [string, string][]; // Can be converted to a map using basic constructor
  events?: [string, string][][]; // each item in outer array can be converted to a map
}

@Injectable()
export class EventLogService {
  constructor(private firebaseFunctions: Functions) {}

  async queryEventLog(mac: string, hoursAgo: number): Promise<EventLogResult[]> {
    const callable = httpsCallable<any, EventLogResult[]>(this.firebaseFunctions, 'eventLog');
    return (await callable({ mac, hoursAgo })).data;
  }
}
